import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21cc8fc0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "channel-status-cell"
};
const _hoisted_2 = {
  key: 1
};
export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelStatusCell',
  props: {
    items: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.channel,
          class: "channel-status-row"
        }, [_createVNode(_component_a_tooltip, {
          title: item.tooltip
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass(["channel-label", item.channel])
          }, _toDisplayString(item.label), 3)]),
          _: 2
        }, 1032, ["title"]), _createElementVNode("span", {
          class: _normalizeClass(["channel-status-dot", item.tone])
        }, null, 2), item.message ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 0,
          title: item.message
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.text), 1)]),
          _: 2
        }, 1032, ["title"])) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.text), 1))]);
      }), 128))]);
    };
  }
});